<!--
 * @Author: QWX
 * @Description:链接文件下载  pdf预览
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-11 09:21:24
-->

<template>
  <span>
    <div v-for="item in fileList" :key="item.guid">
      <el-link type="primary" @click="download(item.guid)">{{item.name}}</el-link>
      <i @click="preView(item)" v-if="item.name.endsWith('.pdf') || item.name.endsWith('.PDF')" class="iconfont icon-fujian-yulan"></i>
    </div>
  </span>
</template>

<script>
import preViewDialog from '@/components/dialog/preViewDialog'
import config from '@/config/config'
export default {
  props: {
    fileId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fileList: []
    }
  },
  watch: {
    fileId: {
      handler() {
        this.getFileList()
      },
      immediate: true
    }
  },
  methods: {
    // pdf文件预览
    preView(item) {
      this.$zl.dialog.openFull(preViewDialog, item)
    },
    // 文件下载
    async download(guid) {
      const result = await this._util.getFileToken(2, 1, guid)
      // 下载文件
      window.open(
        `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${guid}&token=${result}`
      )
    },
    getFileList() {
      this._util.getFileInfo(this.fileId).then(res => {
        this.fileList = res || []
      })
    }

  }
}
</script>
<style lang="scss" scoped>
::v-deep.el-link {
    vertical-align: inherit;
}
.iconfont{
  cursor: pointer;
  font-size: 1em;
  margin-left: 8px;
}
</style>
